import React, { useEffect, useRef, useState } from "react";
import "../../css/newlogin.css";
import * as Yup from "yup";
import { useFormik } from "formik";

const LoginNew = () => {
  let url = "https://server.launchestore.com/";
  // let url = "https://staggingnode.launchestore.com/";
  const [step1, setstep1] = React.useState(true);
  const [timer, setTimer] = useState(300); // 5-minute countdown
  const [isResendDisabled, setIsResendDisabled] = useState(true);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);

  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .required("Please enter Email")
      .email("Please enter valid Email"),
  });

  useEffect(() => {
    if (!step1) {
      // Wait a short moment for DOM update
      setTimeout(() => {
        if (inputs.current[0]) {
          inputs.current[0].focus();
        }
      }, 50);
    }
  }, [step1]);

  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema,
    onSubmit: async (values) => {
      try {
        setError("");
        setSuccess("");
        inputs.current.forEach((input) => {
          if (input) input.value = "";
        });
        fetch(`${url}vendor/sendOtpMailRegister`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json", // Remove this line for FormData
          },
          body: JSON.stringify({
            email: values.email.trim(),
            isVendorLogin: "1",
          }), // Pass FormData as the body
        })
          .then((response) => response.json())
          .then((data) => {
            if (data.success) {
              setSuccess(data.message);
              setstep1(false);
              setIsResendDisabled(true);
              setTimer(300);
              if (inputs.current[0]) {
                inputs.current[0].focus();
              }
            } else {
              setError(data.message);
              resetOtpInputs(); // 🔥 Clear and auto-focus
            }
          })
          .catch((e) => {
            setError(e.message);
            resetOtpInputs(); // 🔥 Clear and auto-focus
          });
      } catch (error) {
        resetOtpInputs(); // 🔥 Clear and auto-focus
        setError(error.message);
      } finally {
        formik.setSubmitting(false);
      }
    },
  });

  useEffect(() => {
    if (!isResendDisabled) return;

    const endTime = Date.now() + timer * 1000;

    const interval = setInterval(() => {
      const remaining = Math.max(0, Math.floor((endTime - Date.now()) / 1000));
      setTimer(remaining);

      if (remaining === 0) {
        setIsResendDisabled(false);
        clearInterval(interval);
      }
    }, 500); // Check twice per second for better accuracy

    return () => clearInterval(interval);
  }, [isResendDisabled]);

  const inputs = useRef([]);

  const handleChange = (e, index) => {
    setError("");
    const value = e.target.value;
    if (/^[0-9]$/.test(value)) {
      if (index < inputs.current.length - 1) {
        inputs.current[index + 1].focus();
      }
    } else {
      e.target.value = "";
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !e.target.value && index > 0) {
      inputs.current[index - 1].focus();
    }
  };

  // format time as mm:ss
  const formatTime = (seconds) => {
    const m = Math.floor(seconds / 60)
      .toString()
      .padStart(2, "0");
    const s = (seconds % 60).toString().padStart(2, "0");
    return `${m}:${s}`;
  };

  const handleOtpVerify = async () => {
    try {
      setLoading(true);
      const otp = inputs.current.map((i) => i.value).join("");

      const response = await fetch(`${url}vendor/emailVerifyOtp`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email: formik.values.email,
          otp: otp,
          isVendorLogin: "1",
        }),
      });

      const data = await response.json();

      if (!data.success) {
        setError(data.message);
        resetOtpInputs();
        return;
      }

      setSuccess(data.message);
      if (data.success) {
        setSuccess(data.message);
        // const url = 'https://register.launchestore.com'
        const url = "https://str.launchestore.com";
        if (!data?.data?.package_id) {
          window.location.href = `${url}/?laststep=3&vendorId=${data?.data?.vendor_id}`;
        } else if (!data?.data?.theme_name) {
          window.location.href = `${url}/?laststep=4&vendorId=${data?.data?.vendor_id}`;
        } else if (data.data.isRegister === "0") {
          window.location.href = `https://${data.data.domain_name}/admin/login?logtemptok=${data.data.temp_token}`;
        } else if (
          data.data.themedevelopverifytoken &&
          data.data.theme_develop_position === "0"
        ) {
          window.location.href = `https://${data.data.domain_name}/home?verifytoken=${data.data.themedevelopverifytoken}`;
        } else if (
          data.data.themedevelopverifytoken &&
          data.data.theme_develop_position === "1"
        ) {
          window.location.href = `https://${data.data.domain_name}/admin/login?logtemptok=${data.data.temp_token}`;
        }
        setLoading(false);
      } else {
        resetOtpInputs(); // 🔥 Clear and auto-focus
        setError(data.message);
        setLoading(false);
      }
    } catch (e) {
      setError(e.message);
      resetOtpInputs();
    } finally {
      setLoading(false);
    }
  };

  const resetOtpInputs = () => {
    inputs.current.forEach((input) => {
      if (input) input.value = "";
    });
    if (inputs.current[0]) {
      inputs.current[0].focus();
    }
  };

  const handleEnterKey = (e) => {
    if (e.key === "Enter") {
      if (step1) {
        formik.handleSubmit(); // Submit email
      } else {
        handleOtpVerify(); // Verify OTP
      }
    }
  };
  return (
    <div className="login-wrapper">
      <div className="overlay" />

      <div className="login-card">
        <div className="loginlogo">
          <svg
            width="350"
            height="102"
            viewBox="0 0 781 102"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M460.052 24.4883V89.2525H447.062V61.6952H419.319V89.2525H406.329V24.4883H419.319V51.1177H447.062V24.4883H460.052Z"
              fill="white"
            />
            <path
              d="M336.472 56.7787C336.472 50.4074 337.895 44.7166 340.741 39.7062C343.648 34.6339 347.576 30.706 352.524 27.9224C357.535 25.077 363.133 23.6543 369.318 23.6543C376.556 23.6543 382.896 25.51 388.339 29.2214C393.783 32.9328 397.587 38.067 399.752 44.6238H384.814C383.329 41.531 381.226 39.2113 378.504 37.6649C375.844 36.1185 372.752 35.3453 369.226 35.3453C365.452 35.3453 362.081 36.2422 359.112 38.036C356.205 39.768 353.916 42.2423 352.246 45.4589C350.638 48.6754 349.834 52.4487 349.834 56.7787C349.834 61.0468 350.638 64.8201 352.246 68.0985C353.916 71.3151 356.205 73.8203 359.112 75.6142C362.081 77.3462 365.452 78.2122 369.226 78.2122C372.752 78.2122 375.844 77.4389 378.504 75.8925C381.226 74.2842 383.329 71.9337 384.814 68.8408H399.752C397.587 75.4595 393.783 80.6246 388.339 84.336C382.958 87.9856 376.618 89.8103 369.318 89.8103C363.133 89.8103 357.535 88.4186 352.524 85.635C347.576 82.7896 343.648 78.8617 340.741 73.8512C337.895 68.8408 336.472 63.15 336.472 56.7787Z"
              fill="white"
            />
            <path
              d="M329.957 89.2516H316.967L287.554 44.8073V89.2516H274.564V24.3945H287.554L316.967 68.9316V24.3945H329.957V89.2516Z"
              fill="white"
            />
            <path
              d="M227.157 24.4883V64.5716C227.157 68.9634 228.301 72.3347 230.59 74.6852C232.879 76.9739 236.095 78.1183 240.24 78.1183C244.446 78.1183 247.693 76.9739 249.982 74.6852C252.271 72.3347 253.415 68.9634 253.415 64.5716V24.4883H266.498V64.4788C266.498 69.9841 265.292 74.6543 262.879 78.4894C260.529 82.2627 257.343 85.1081 253.322 87.0257C249.364 88.9432 244.941 89.902 240.054 89.902C235.229 89.902 230.837 88.9432 226.879 87.0257C222.982 85.1081 219.889 82.2627 217.6 78.4894C215.311 74.6543 214.167 69.9841 214.167 64.4788V24.4883H227.157Z"
              fill="white"
            />
            <path
              d="M196.084 76.9111H170.29L166.022 89.2516H152.382L175.671 24.3945H190.796L214.085 89.2516H200.352L196.084 76.9111ZM192.558 66.5191L183.187 39.4258L173.816 66.5191H192.558Z"
              fill="white"
            />
            <path
              d="M129.95 78.9533H151.291V89.2525H116.96V24.4883H129.95V78.9533Z"
              fill="white"
            />
            <path
              d="M755.789 35.2201V51.4576H777.594V61.7568H755.789V78.9221H780.378V89.4996H742.799V24.6426H780.378V35.2201H755.789Z"
              fill="white"
            />
            <path
              d="M721.244 89.5006L706.955 64.2629H700.832V89.5006H687.842V24.7363H712.151C717.162 24.7363 721.43 25.6333 724.956 27.4271C728.482 29.1591 731.111 31.5406 732.843 34.5716C734.636 37.5407 735.533 40.881 735.533 44.5924C735.533 48.8605 734.296 52.7266 731.822 56.1906C729.348 59.5927 725.667 61.9433 720.781 63.2423L736.276 89.5006H721.244ZM700.832 54.5205H711.688C715.213 54.5205 717.842 53.6854 719.574 52.0153C721.306 50.2833 722.172 47.9018 722.172 44.8708C722.172 41.9016 721.306 39.6129 719.574 38.0047C717.842 36.3345 715.213 35.4994 711.688 35.4994H700.832V54.5205Z"
              fill="white"
            />
            <path
              d="M649.547 90.1522C643.485 90.1522 637.918 88.7294 632.846 85.884C627.773 83.0386 623.753 79.1107 620.784 74.1003C617.815 69.028 616.33 63.3062 616.33 56.935C616.33 50.6255 617.815 44.9656 620.784 39.9552C623.753 34.8829 627.773 30.9241 632.846 28.0787C637.918 25.2333 643.485 23.8105 649.547 23.8105C655.671 23.8105 661.238 25.2333 666.249 28.0787C671.321 30.9241 675.311 34.8829 678.218 39.9552C681.187 44.9656 682.672 50.6255 682.672 56.935C682.672 63.3062 681.187 69.028 678.218 74.1003C675.311 79.1107 671.321 83.0386 666.249 85.884C661.176 88.7294 655.609 90.1522 649.547 90.1522ZM649.547 78.554C653.444 78.554 656.877 77.688 659.846 75.956C662.815 74.1621 665.135 71.626 666.805 68.3476C668.475 65.0691 669.31 61.2649 669.31 56.935C669.31 52.605 668.475 48.8317 666.805 45.6151C665.135 42.3367 662.815 39.8315 659.846 38.0995C656.877 36.3675 653.444 35.5015 649.547 35.5015C645.65 35.5015 642.186 36.3675 639.155 38.0995C636.186 39.8315 633.866 42.3367 632.196 45.6151C630.526 48.8317 629.691 52.605 629.691 56.935C629.691 61.2649 630.526 65.0691 632.196 68.3476C633.866 71.626 636.186 74.1621 639.155 75.956C642.186 77.688 645.65 78.554 649.547 78.554Z"
              fill="white"
            />
            <path
              d="M615.808 24.7363V35.2211H598.55V89.5006H585.56V35.2211H568.302V24.7363H615.808Z"
              fill="white"
            />
            <path
              d="M543.36 90.1522C538.844 90.1522 534.762 89.3789 531.112 87.8325C527.524 86.2861 524.679 84.0592 522.576 81.152C520.473 78.2447 519.39 74.8116 519.328 70.8528H533.246C533.432 73.5126 534.36 75.6158 536.03 77.1622C537.762 78.7086 540.112 79.4818 543.081 79.4818C546.112 79.4818 548.494 78.7705 550.226 77.3478C551.958 75.8632 552.824 73.9456 552.824 71.5951C552.824 69.6775 552.236 68.1001 551.061 66.863C549.886 65.6259 548.401 64.6671 546.607 63.9867C544.875 63.2444 542.463 62.4402 539.37 61.5742C535.164 60.3371 531.731 59.1309 529.071 57.9556C526.473 56.7185 524.215 54.8937 522.298 52.4813C520.442 50.007 519.514 46.7286 519.514 42.646C519.514 38.8109 520.473 35.4706 522.39 32.6252C524.308 29.7797 526.999 27.6147 530.463 26.1302C533.927 24.5838 537.885 23.8105 542.339 23.8105C549.02 23.8105 554.432 25.4498 558.577 28.7282C562.783 31.9447 565.103 36.4603 565.536 42.2749H551.247C551.123 40.048 550.164 38.2232 548.37 36.8005C546.638 35.3159 544.319 34.5737 541.411 34.5737C538.875 34.5737 536.834 35.2232 535.287 36.5221C533.803 37.8211 533.061 39.7078 533.061 42.1821C533.061 43.9141 533.617 45.3677 534.731 46.543C535.906 47.6564 537.329 48.5843 538.999 49.3265C540.731 50.007 543.143 50.8111 546.236 51.739C550.442 52.9761 553.875 54.2132 556.535 55.4504C559.195 56.6875 561.484 58.5432 563.401 61.0175C565.319 63.4918 566.278 66.7393 566.278 70.76C566.278 74.224 565.381 77.4405 563.587 80.4097C561.793 83.3788 559.164 85.7603 555.7 87.5542C552.236 89.2862 548.123 90.1522 543.36 90.1522Z"
              fill="white"
            />
            <path
              d="M494.886 80.4823C498.69 81.3963 502.425 81.1151 506.091 79.6386C509.826 78.1621 512.661 75.631 514.598 72.0452C512.869 76.6153 510.483 80.2362 507.439 82.908C504.396 85.5797 501.18 87.232 497.791 87.8648C494.471 88.4272 491.047 88.2163 487.52 87.232C484.062 86.2477 480.915 84.5954 478.079 82.2752C475.312 79.8847 473.03 76.8614 471.232 73.2053C469.433 69.5492 468.534 65.6119 468.534 61.3933C468.534 55.4874 470.125 50.179 473.307 45.4683C476.557 40.7576 480.742 37.6991 485.86 36.2929C490.217 35.3086 494.263 35.2734 497.998 36.1875C501.733 37.1015 504.811 38.8592 507.232 41.4607C509.653 43.9918 510.794 46.769 510.655 49.7923C510.517 52.0422 509.583 53.9054 507.854 55.3819C506.194 56.7881 504.292 57.7724 502.148 58.3349C500.004 58.827 497.618 59.5301 494.99 60.4442C492.431 61.3582 490.459 62.4128 489.076 63.6081C486.932 65.5064 485.756 67.6509 485.549 70.0414C485.41 72.4319 486.206 74.6115 487.935 76.5801C489.664 78.4785 491.981 79.7792 494.886 80.4823ZM479.635 64.8736C480.673 68.4594 482.194 71.4827 484.2 73.9435C483.37 70.7093 483.266 68.1782 483.889 66.3501C484.58 64.4518 485.756 62.7644 487.416 61.2879C489.076 59.7411 490.771 58.5107 492.5 57.5966C494.298 56.6123 495.854 55.4171 497.168 54.0109C498.483 52.5344 499.14 50.9524 499.14 49.265C499.14 44.1324 497.376 40.8279 493.848 39.3514C490.529 38.0155 487.278 38.6483 484.096 41.2497C479.739 44.6949 477.802 50.0384 478.286 57.2802C478.425 59.6708 478.874 62.2019 479.635 64.8736Z"
              fill="white"
            />
            <path
              d="M48.7543 0C63.5159 0 75.7153 11.8917 76.0228 26.6533H78.5853C83.6083 26.5508 87.811 30.2407 88.6312 35.1611L97.3451 90.5176C98.2531 96.471 93.6981 101.928 87.5912 101.999H10.1078C3.85473 101.999 -0.963092 96.3605 0.164429 90.21L9.80017 35.4688C10.6203 30.7533 14.824 27.165 19.642 27.165H21.4867C21.4868 19.9894 24.3573 13.1216 29.4828 7.99609C34.6083 2.87063 41.4761 0.000102893 48.7543 0ZM27.7357 89.0781C27.5307 88.7706 27.0179 88.7706 26.7103 89.0781L21.4818 93.999C21.1748 94.2042 21.1747 94.716 21.4818 95.0234C21.5843 95.1259 21.6871 95.2285 21.892 95.2285C22.097 95.2285 22.3022 95.1259 22.5072 95.0234L27.7357 90.1035C28.043 89.8985 28.043 89.3856 27.7357 89.0781ZM58.684 74.5215C54.7885 76.9818 49.6627 79.5446 43.307 81.9023C44.5371 84.9775 44.2296 88.3602 43.5121 91.0254C43.3071 91.948 43.6148 92.8713 44.2299 93.4863C44.9474 94.1012 45.8699 94.2039 46.7924 93.8965C58.9912 88.4634 59.299 79.032 58.684 74.5215ZM23.3207 83.6465C23.1157 83.339 22.6028 83.3391 22.2953 83.6465L16.6566 88.9775C16.3497 89.1827 16.3497 89.6945 16.6566 90.002C16.7591 90.1044 16.862 90.2069 17.0668 90.207C17.2718 90.207 17.5795 90.1045 17.682 90.002L23.3207 84.6719C23.628 84.4668 23.628 83.954 23.3207 83.6465ZM29.0697 83.0332C28.8647 82.7257 28.3519 82.7258 28.0443 83.0332L21.8939 88.7744C21.5864 88.9794 21.5864 89.4913 21.8939 89.7988C21.9964 89.9013 22.0991 90.0039 22.3041 90.0039C22.5089 90.0039 22.7135 90.0036 22.9183 89.7988L29.0697 84.0586C29.3771 83.8535 29.3771 83.3407 29.0697 83.0332ZM25.4711 76.7051L35.9252 87.415L39.1527 84.2646L28.6986 73.5547L25.4711 76.7051ZM74.9926 35.3672C69.662 35.4697 58.0778 36.7 48.3392 46.3359C48.3392 46.3359 38.9078 54.7423 32.4496 72.9893L36.0375 76.6797L36.14 76.7822L39.7279 80.4727C58.0774 74.527 66.6888 65.1982 66.6888 65.1982C76.6324 55.7672 77.9652 43.978 78.0677 38.4424C78.0676 37.6225 77.7598 36.905 77.1449 36.29C76.6324 35.6751 75.8125 35.3673 74.9926 35.3672ZM38.8998 54.123C34.2868 53.303 24.8553 53.5081 19.2172 65.502C18.8073 66.322 18.9098 67.347 19.5248 68.0645C20.1397 68.7819 21.0623 69.0896 21.9847 68.8848C24.65 68.2697 28.0334 67.9623 31.1088 69.2949C33.569 62.9392 36.337 57.916 38.8998 54.123ZM48.7543 6.25293C37.2733 6.25314 27.8424 15.6841 27.7396 27.165L69.7699 26.6533C69.4624 15.3771 60.133 6.25293 48.7543 6.25293Z"
              fill="white"
            />
          </svg>
        </div>

        <h2>Welcome Back!</h2>
        <p className="subtitle">
          Sign in to manage your products, view analytics, and grow your
          business.
        </p>

        <form onSubmit={formik.handleSubmit} className="disble-btn">
          <input
            type="email"
            placeholder="Enter your Email Address..."
            name="email"
            onChange={(e) => {
              formik.handleChange(e);
              setstep1(true);
              setError("");
              setSuccess("");
            }}
            value={formik.values.email}
            onBlur={formik.handleBlur}
            onKeyDown={handleEnterKey}
          />
          {formik.touched.email && formik.errors.email && (
            <div className="error">{formik.errors.email}</div>
          )}

          {!step1 && (
            <div className="otp-container">
              {[0, 1, 2, 3].map((i) => (
                <input
                  key={i}
                  type="text"
                  maxLength="1"
                  ref={(el) => (inputs.current[i] = el)}
                  onChange={(e) => handleChange(e, i)}
                  onKeyDown={(e) => {
                    handleKeyDown(e, i);
                    handleEnterKey(e);
                  }}
                  className="otp-box"
                />
              ))}
            </div>
          )}
          {step1 && (
            <button
              type="submit"
              disabled={formik.isSubmitting}
              className="btn-dis"
            >
              {formik.isSubmitting ? (
                <div className="loader"></div>
              ) : (
                "Verify with OTP →"
              )}
            </button>
          )}
          {!step1 && (
            <>
              <button
                type="button"
                onClick={handleOtpVerify}
                disabled={loading}
                className="btn-dis"
              >
                {loading ? <div className="loader"></div> : "Verify"}
              </button>
              <button
                type="submit"
                disabled={isResendDisabled}
                className="btn-dis"
              >
                Resend OTP
              </button>
              {isResendDisabled && (
                <p
                  style={{
                    marginTop: "10px",
                    color: "#666",
                    width: "100%",
                    textAlign: "center",
                    maxWidth: "100%",
                  }}
                >
                  You can resend OTP in <strong>{formatTime(timer)}</strong>
                </p>
              )}
            </>
          )}
          {error !== "" && <div className="error text-center">{error}</div>}
          {success !== "" && error === "" && (
            <div className="success">{success}</div>
          )}
        </form>
      </div>
    </div>
  );
};

export default LoginNew;
